(() => {
  'use strict';
  const node = document.getElementById('namorra-niche-config');
  const catalog = window.NAMORRA_NICHE_CATALOG;
  if (!node || !catalog) return;
  let cfg; try { cfg = JSON.parse(node.textContent); } catch { return; }
  if (cfg.designMode) return;
  const params = new URLSearchParams(location.search);
  const storageKey = 'namorra_browsing_niche_v1';
  const read = () => { try { return sessionStorage.getItem(storageKey); } catch { return null; } };
  const write = value => { try { value ? sessionStorage.setItem(storageKey, value) : sessionStorage.removeItem(storageKey); } catch {} };
  const modeKey = 'namorra_browsing_entry_v2';
  const getMode = () => { try { return sessionStorage.getItem(modeKey); } catch { return null; } };
  const setMode = value => { try { sessionStorage.setItem(modeKey, value); } catch {} };
  const aliases = {'baby-parenting':'namorra-baby','cycling-accessories':'namorra-cycling','outdoor-travel-accessories':'namorra-outdoor','home-comfort-accessories':'namorra-home','personal-care-devices':'namorra-beauty'};
  const normalize = value => aliases[value] || value;
  const valid = key => Boolean(cfg.niches[key] && catalog.niches[key]);
  let internalReferrer = false;
  try { internalReferrer = new URL(document.referrer).origin === location.origin; } catch {}
  const navigationType = performance.getEntriesByType('navigation')[0]?.type || 'navigate';
  const freshArrival = !internalReferrer && navigationType === 'navigate';
  const freeBrowse = () => { write(null); setMode('all'); };
  if (params.get('namorra_browse') === 'all' || (cfg.page === 'index' && freshArrival)) {
    freeBrowse();
    return;
  }
  let key = normalize(read());
  if (cfg.page === 'product' && (freshArrival || (!getMode() && !internalReferrer))) {
    key = cfg.productNiche || catalog.productMap[cfg.product];
    if (valid(key)) { write(key); setMode('niche'); }
    else { freeBrowse(); return; }
  } else if (getMode() !== 'niche') {
    freeBrowse();
    return;
  }
  if (!valid(key)) { freeBrowse(); return; }
  const niche = cfg.niches[key];
  const membership = catalog.niches[key];
  const allowed = new Set(membership.handles);
  if (cfg.productNiche === key) allowed.add(cfg.product);
  const root = new URL(cfg.root, location.origin);
  const home = new URL(niche.url, location.origin);
  home.searchParams.set('view', niche.view);
  home.searchParams.set('nn', key);
  const all = new URL(root); all.searchParams.set('namorra_browse', 'all');
  const isNicheCollection = cfg.page === 'collection' && (cfg.collection === key || membership.groups.some(group => group.handle === cfg.collection));
  if (cfg.page === 'index') {
    if (params.has('preview_theme_id')) home.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
    location.replace(home.href); return;
  }
  document.documentElement.classList.add('nn-active');
  const handleOf = href => {
    try { const u = new URL(href, location.origin); return u.origin === location.origin ? u.pathname.match(/\/products\/([^/]+)/)?.[1] : null; } catch { return null; }
  };
  const guard = scope => {
    if (isNicheCollection) scope.querySelectorAll('[data-niche-product]').forEach(card => allowed.add(card.dataset.nicheProduct));
    scope.querySelectorAll('a[href]').forEach(a => {
      let u; try { u = new URL(a.getAttribute('href'), location.origin); } catch { return; }
      if (u.origin !== location.origin || a.dataset.nnAll !== undefined) return;
      if ((u.pathname.replace(/\/$/, '') === root.pathname.replace(/\/$/, '') && !u.hash) || /\/collections\/?$/.test(u.pathname)) a.href = home.href;
      const handle = handleOf(a.href);
      if (handle && !allowed.has(handle) && !a.closest('.cart-item,cart-items,.cart-items')) {
        const card = a.closest('product-card,.product-card,.card--product,.nc-related-card,.npc-card');
        if (card) (card.closest('li') || card).hidden = true;
        else if (a.closest('main')) a.hidden = true;
      }
    });
    scope.querySelectorAll('footer a[href],.footer a[href]').forEach(a => {
      const href = a.getAttribute('href');
      if (/\/(collections|products)\//.test(href) && !href.includes('/collections/' + key) && !allowed.has(handleOf(href))) a.hidden = true;
    });
  };
  const start = async () => {
    if (isNicheCollection) document.querySelectorAll('[data-niche-product]').forEach(card => allowed.add(card.dataset.nicheProduct));
    const nav = document.createElement('nav'); nav.className = 'nn-nav'; nav.setAttribute('aria-label', niche.title);
    const homeLink = document.createElement('a'); homeLink.href = home.href; homeLink.textContent = niche.title; nav.append(homeLink);
    const form = document.createElement('form'); form.action = home.pathname;
    for (const [name, value] of [['view',niche.view],['nn',key],['nn_cat',params.get('nn_cat') || '']]) {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; form.append(input);
    }
    const search = document.createElement('input'); search.type = 'search'; search.name = 'nn_q'; search.placeholder = cfg.labels.search; search.setAttribute('aria-label', cfg.labels.search); search.value = params.get('nn_q') || ''; form.append(search); nav.append(form);
    const allLink = document.createElement('a'); allLink.href = all.href; allLink.textContent = cfg.labels.all; allLink.dataset.nnAll = ''; allLink.addEventListener('click', freeBrowse); nav.append(allLink);
    const header = document.querySelector('store-header'); if (header) header.insertAdjacentElement('afterend', nav);
    guard(document);
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return; scheduled = true;
      setTimeout(() => { scheduled = false; guard(document); }, 200);
    }).observe(document.body, {childList:true,subtree:true});
    if (isNicheCollection) {
      const cards = [...document.querySelectorAll('[data-niche-product]')];
      let selected = params.get('nn_cat') || '';
      const query = (params.get('nn_q') || '').trim().toLocaleLowerCase();
      const filter = () => {
        const group = membership.groups.find(g => g.handle === selected);
        let count = 0;
        cards.forEach(card => {
          const visible = (!group || group.products.includes(card.dataset.nicheProduct)) && (!query || card.textContent.toLocaleLowerCase().includes(query));
          card.hidden = !visible; if (visible) count++;
        });
        const empty = document.querySelector('[data-nn-no-results]');
        if (empty) { empty.hidden = count > 0; empty.textContent = cfg.labels.noResults.replace('[query]', params.get('nn_q') || ''); }
      };
      const holder = document.querySelector('[data-nn-filters]');
      if (holder && membership.groups.length > 1) {
        const select = document.createElement('select'); select.setAttribute('aria-label', cfg.labels.categories);
        const option = document.createElement('option'); option.value = ''; option.textContent = cfg.labels.all; select.append(option);
        membership.groups.forEach(group => { const o = document.createElement('option'); o.value = group.handle; o.textContent = niche.groups[group.handle] || group.handle; select.append(o); });
        select.value = selected;
        select.addEventListener('change', () => {
          selected = select.value; form.elements.nn_cat.value = selected;
          const url = new URL(location.href); selected ? url.searchParams.set('nn_cat', selected) : url.searchParams.delete('nn_cat'); history.replaceState(null, '', url); filter();
        });
        holder.append(select);
      }
      filter(); return;
    }
    if (cfg.page !== 'product') return;
    try {
      const relatedUrl = new URL(home);
      relatedUrl.searchParams.set('view', 'namorra-products');
      const response = await fetch(relatedUrl.href, {credentials:'same-origin'}); if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const stylesheet = doc.querySelector('link[href*="namorra-premium-collection.css"]');
      if (stylesheet && !document.querySelector('link[href*="namorra-premium-collection.css"]')) {
        const copy = stylesheet.cloneNode(true);
        document.head.append(copy);
      }
      const availableCards = [...doc.querySelectorAll('[data-niche-product]')].filter(card => card.dataset.nicheProduct !== cfg.product && card.dataset.nicheAvailable === 'true');
      const curatedIds = Array.from(document.querySelectorAll('[data-fan-related-id]'), item => item.dataset.fanRelatedId);
      const cardsById = new Map(availableCards.map(card => [card.dataset.collectionProduct, card]));
      const cards = curatedIds.length ? curatedIds.map(id => cardsById.get(id)).filter(Boolean) : availableCards.slice(0, 4);
      if (!cards.length) return;
      const section = document.createElement('section'); section.className = 'container nn-related';
      const heading = document.createElement('h2'); heading.className = 'h3'; heading.textContent = niche.title; section.append(heading);
      const list = document.createElement('ul'); list.className = 'nn-product-grid'; list.setAttribute('role','list');
      cards.forEach(card => { allowed.add(card.dataset.nicheProduct); card.querySelectorAll('[id]').forEach(el => el.removeAttribute('id')); list.append(card); });
      section.append(list); const main = document.querySelector('main'); if (main) main.append(section); guard(section);
    } catch {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
